import React from 'react'


const Message=()=>{

    return(
        <>
        <h1>Mensajexxx</h1>
        </>
    )
}

export default Message